import { Component, DestroyRef, inject, OnInit } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { ComboBox } from '@grapecity/wijmo.input'

import { HrGoalLookup, ListItem, QuarterlyMeasurable, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './quarterly-measurable.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class QuarterlyMeasurableComponent extends RepositoryModal<QuarterlyMeasurable> implements OnInit {
    private destroyRef = inject(DestroyRef)

    goalDirectionList: ListItem<number>[] = [
        new ListItem<number>(0, 'At least (>=)'),
        new ListItem<number>(1, 'At most (<=)'),
        new ListItem<number>(2, 'Between'),
    ]

    formatList: ListItem<string>[] = [
        new ListItem<string>('n0', 'Number'),
        new ListItem<string>('c0', 'Currency'),
        new ListItem<string>('c1m', 'Currency ($M)'),
        new ListItem<string>('p1', 'Percent'),
    ]

    boolList: ListItem<boolean>[] = [new ListItem(true, 'Yes'), new ListItem(false, 'No')]

    aggregationList: ListItem<number>[] = [
        new ListItem<number>(0, 'Last week in quarter'),
        new ListItem<number>(1, 'Sum of weeks'),
        new ListItem<number>(2, 'Average of weeks'),
        new ListItem<number>(3, 'Lowest week'),
        new ListItem<number>(4, 'Highest week'),
    ]

    metricList: ListItem<string | null>[] = [new ListItem<string | null>(null, 'None (manual entry)')]
    metricsLoaded = false

    calculatedSourceList: ListItem<number>[] = [
        new ListItem<number>(0, 'None'),
        new ListItem<number>(1, 'Revenue Earned (YTD)'),
        new ListItem<number>(2, 'Revenue Earned Profit % (YTD)'),
        new ListItem<number>(3, 'Bid Analytics Won Amount (Quarter)'),
    ]

    ngOnInit() {
        const selectedMetricId = this.target.hrGoalId
        const selectedAggregation = this.target.aggregation

        if (this.isAdding) {
            this.target.aggregation = 0
            this.target.hrGoalId = null
            this.target.calculatedSource = 0
        }

        this.services.data
            .get<HrGoalLookup[]>('/api/HrGoal/GetForLookup')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: goals => {
                    const sorted = [...goals].sort((a, b) => a.order - b.order || a.name.localeCompare(b.name))
                    this.metricList = [
                        new ListItem<string | null>(null, 'None (manual entry)'),
                        ...sorted.map(g => new ListItem<string | null>(g.id, g.name)),
                    ]
                    if (!this.isAdding) {
                        this.target.hrGoalId = selectedMetricId
                        this.target.aggregation = selectedAggregation
                    }
                    this.metricsLoaded = true
                },
            })
    }

    get hasMetricSelected(): boolean {
        return !!this.target.hrGoalId
    }

    onMetricComboInitialized(combo: ComboBox) {
        combo.selectedValue = this.target.hrGoalId
    }

    onMetricChanged() {
        if (this.target.hrGoalId) {
            this.target.calculatedSource = 0
        } else {
            this.target.aggregation = 0
        }
    }

    onCalculatedSourceChanged() {
        if (this.target.calculatedSource) {
            this.target.hrGoalId = null
            this.target.aggregation = 0
        }
    }
}
